import { Box, Skeleton, Stack, SxProps } from "@mui/material";

interface IProps {
  sx?: SxProps;
  width?: number;
}

const IssueListItemSkeleton = (props: IProps) => {
  return (
    <Stack sx={{ ...props.sx }}>
      <Box sx={{ pl: 1.25 }}>
        <Skeleton width={100} height={30} sx={{ borderRadius: "5px" }} />
      </Box>

      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <Skeleton variant="circular" width={14} height={14} />
        <Skeleton width={props.width ? props.width : 300} height={26} />
      </Stack>

      <Stack direction="row" spacing={0.5} sx={{ pl: 1.25, alignItems: "center" }}>
        <Skeleton variant="circular" width={18} height={18} />
        <Skeleton width={30} height={30} />
        <Skeleton width={30} height={30} />
      </Stack>
    </Stack>
  );
};

export { IssueListItemSkeleton };
